import { Share } from "@mui/icons-material";

export const share = (props) => {
  return <Share {...props} />;
};
